<template>
	<div
		class="text-center ss"
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elIconType="node.iconType"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getMainWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div :class="getWrapperClass(node)">
			<!-- sticky button -->
			<a
				v-if="node.options.isFloating"
				:href="'#'"
				class="btn btn-secondary btn-block"
				@click.stop.prevent
				:v-tooltip="'Sticky Button Placeholder'"
				title="Sticky Button Placeholder"
			>
				<div class="d-flex flex-column">
					<i class="material-icons">call_to_action</i>
					<!-- <small class="text-white-50">Sticky Button Placeholder</small> -->
				</div>
			</a>

			<!-- normal button -->
			<a
				v-else
				:href="waLink"
				:class="getButtonClass(node)"
				:style="getStyle(node)"
				@click.stop.prevent="onNodeClick(node)"
				:target="node.options.inNewTab ? '_blank' : '_self'"
			>
				<div class="d-flex align-items-center">
					<div class="mx-auto d-flex align-items-center">
						<template v-if="node.options.iconKey && node.options.iconKey !== '' && node.options.iconPosition === 'before'">
							<i :style="getIconStyle(node, 'before')" :class="getIcon(node)"></i>
						</template>
						<!-- <span class="mx-auto" v-html="node.options && node.options.content"></span> -->
						<div class="mx-auto">
							<NodeEditor
								:key="node.key"
								v-model="node.options.text"
								@focus="onNodeClick(node)"
							/>
						</div>
						<template v-if="node.options.iconKey && node.options.iconKey !== '' && node.options.iconPosition === 'after'">
							<i :style="getIconStyle(node, 'after')" :class="getIcon(node)"></i>
						</template>
					</div>
				</div>
			</a>
		</div>

		<!-- sticky / floating -->
		<div class="button-sticky-wrapper" v-if="node.options.isFloating">
			<a
				:href="waLink"
				:class="getButtonClass(node)"
				:style="getStyle(node)"
				@click.stop.prevent
				:target="node.options.inNewTab ? '_blank' : '_self'"
			>
				<div class="d-flex align-items-center">
					<div class="mx-auto d-flex align-items-center">
						<template v-if="node.options.iconKey && node.options.iconKey !== '' && node.options.iconPosition === 'before'">
							<i :style="getIconStyle(node, 'before')" :class="getIcon(node)"></i>
						</template>
						<!-- <span class="mx-auto" v-html="node.options && node.options.content"></span> -->
						<div class="mx-auto">
							<NodeEditor
								:key="node.key"
								v-model="node.options.text"
								@focus="onNodeClick(node)"
							/>
						</div>
						<template v-if="node.options.iconKey && node.options.iconKey !== '' && node.options.iconPosition === 'after'">
							<i :style="getIconStyle(node, 'after')" :class="getIcon(node)"></i>
						</template>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
// eslint-disable-next-line
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
// eslint-disable-next-line
import NodeEditor from '@/components/funnels/pagebuilder/nodes/NodeEditor.vue';
import {
	getNodeStyle,
	generateWaUrl,
	formatWaNumber,
	getIcon,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeButtonWa',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		NodeEditor,
	},
	computed: {
		waLink() {
			const phone = this.node.options && this.node.options.phoneNumber && this.node.options.phoneNumber !== ''
				? formatWaNumber(this.node.options.phoneNumber)
				: '62812345678';
			const message = this.node.options.message;
			const url = generateWaUrl(phone, message);
			return url;
		},
	},
	watch: {},
	updated() {
		this.$nextTick(
			// eslint-disable-next-line
			function() {
				this.$bus.$on('button-options-change', (status) => {
					console.log('status: ', status);
				});
			}.bind(this),
		);
	},
	methods: {
		getWrapperClass({ options }) {
			let pClass = '';
			if (options && options.align) {
				pClass += ` text-${options.align}`;
			}

			return pClass;
		},
		getButtonClass(node) {
			let pClass = `btn ${node.class || ''}`;

			const { options } = node;
			if (options && options.style && options.style === 'block') {
				pClass += ' btn-block';
			}

			return pClass;
		},
		getMainWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'text-color',
				'font-family',
				'font-weight',
				'font-size',
				'font-style',
				'text-decoration',
				'line-height',
				'border',
				'box-shadow',
				'bg-color',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getIcon(node) {
			// const icon = `${node.options.iconStyle} fa-${node.options.iconKey}`;
			// return icon;
			const iconKey = node.options.iconKey;
			const iconStyle = node.options.iconStyle;
			return getIcon(iconKey, iconStyle);
		},
		getIconStyle(node, position) {
			let style = '';
			if (node && node.options && node.options.iconSpacing && position === 'before') {
				style = `margin-right: ${node.options.iconSpacing}px`;
			} else if (node && node.options && node.options.iconSpacing && position === 'after') {
				style = `margin-left: ${node.options.iconSpacing}px`;
			}
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style scoped></style>
